<template>
    <footer class="bg-white position-relative py-2" style="border-top: 1px solid #eeeeee;">
      <div class="container-fluid">
        <div class="row d-flex flex-column aling-items-center justify-content-center text-center">
          
          <div class="footer_images">
            <img src="../../../assets/Picture1.jpg" alt="CIFASD" style="margin-right:18px">
            <img src="../../../assets/Picture2.png" alt="NIH" style="width: 9rem; margin-left: .25rem;">
            <img src="../../../assets/Picture3.png" alt="OXFORD" style="width: 9rem;margin-left:-5px;">
            <img src="../../../assets/Picture4.jpg" alt="BDI" style="width: 9rem; margin-left:-19px;">
            <img src="../../../assets/Picture5.png" alt="WRH" style="width: 9rem; margin-left:-24px;">
            
            
          </div>
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: "FooterComponent",
    data() {
      return {
        currentYear: new Date().getFullYear(),
      };
    },
  };
  </script>
  
  <style scoped>
    .footer_images img{
        width: 15rem;
        aspect-ratio: 3/2;
        object-fit: contain;
    }
  </style>
  